"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSearchParams = exports.stringify = exports.parse = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactRouterDom = require("react-router-dom");
var _queryString = _interopRequireDefault(require("query-string"));
var _constants = require("../constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; } /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Copyright (c) 2022, salesforce.com, inc.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * SPDX-License-Identifier: BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */ // Constants
const PARSE_OPTIONS = {
  parseBooleans: true,
  parseNumbers: true
};

/*
 * This hook will return all the location search params pertinant
 * to the product list page.
 */
const useSearchParams = (searchParams = _constants.DEFAULT_SEARCH_PARAMS) => {
  const {
    search
  } = (0, _reactRouterDom.useLocation)();

  // Encode the search query, including preset values.
  const searchParamsObject = _objectSpread(_objectSpread({}, searchParams), parse(search.substring(1)));
  return [searchParamsObject, {
    stringify,
    parse
  }];
};

/**
 * Encode's the provided search parameters object, paying special attention to ensure
 * that the child `refine` object is alway encoded correctly.
 *
 * @param {Object} searchParamsObj
 * @returns
 */
exports.useSearchParams = useSearchParams;
const stringify = searchParamsObj => {
  let searchParamsObjCopy = _objectSpread({}, searchParamsObj);

  // "stringify" the nested refinements
  searchParamsObjCopy.refine = Object.keys(searchParamsObjCopy.refine).map(key => _queryString.default.stringify({
    [key]: searchParamsObjCopy.refine[key]
  }, {
    arrayFormat: 'separator',
    arrayFormatSeparator: '|',
    encode: false
  }));

  // "stringify" the entire object
  searchParamsObjCopy = _queryString.default.stringify(searchParamsObjCopy);
  return searchParamsObjCopy;
};

/**
 * Decode's the provided query string representation of a search parameter object, paying
 * special attention to also decode the 'refine' object.
 *
 * @param {Object} searchParamsStr
 * @param {Boolean} parseRefine - opt out of parsing the inner refine object.
 * @returns
 */
exports.stringify = stringify;
const parse = (searchParamsStr, parseRefine = true) => {
  const params = _queryString.default.parse(searchParamsStr, PARSE_OPTIONS);

  // Ensure the refinments is an array (make it easier to manipulate).
  params.refine = Array.isArray(params.refine) ? params.refine : [params.refine];

  // Parse the nested refinement entries.
  if (parseRefine) {
    // @ts-ignore
    params.refine = params.refine.reduce((acc, curr) => {
      return _objectSpread(_objectSpread({}, acc), _queryString.default.parse(curr, _objectSpread(_objectSpread({}, PARSE_OPTIONS), {}, {
        arrayFormat: 'separator',
        arrayFormatSeparator: '|'
      })));
    }, {});
  }
  return params;
};
exports.parse = parse;